/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateVernehmlassungDto } from '../../models/lexplus-create-vernehmlassung-dto';
import { LexplusVernehmlassungDetailDto } from '../../models/lexplus-vernehmlassung-detail-dto';

export interface VernehmlassungControllerCreateV1$Params {
      body: LexplusCreateVernehmlassungDto
}

export function vernehmlassungControllerCreateV1(http: HttpClient, rootUrl: string, params: VernehmlassungControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusVernehmlassungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, vernehmlassungControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusVernehmlassungDetailDto>;
    })
  );
}

vernehmlassungControllerCreateV1.PATH = '/v1/vernehmlassung';
